import { IconButton } from '@mui/material';
import '../../../css/indent.css'
import { Delete, School, Sell, EmojiEvents } from "@mui/icons-material"

export default function Item({data, edit, onRemove}){

    const icoSx = {color: 'white'};

    const icons = {
        course: <School sx={icoSx} />,
        reward: <EmojiEvents sx={icoSx} />,
        other: <Sell sx={icoSx} />
    }
    

    const amount = data.quantity * data.price;

    const tax = amount * data.taxRate;

    const taxedAmount = amount + tax;

    const key = data.id || (data.class + data.code);


    return <div className="item" data-key={key}>

        <div className="item-left">

            <div className="item-img">

                <div className="item-ico">

                    {icons[data.class] || icons.other}

                </div>

                <span className="item-quantity">
                    {data.quantity}
                </span>

            </div>

            <div className="item-product">

                <span className="item-title">{data.title}</span>

                <br/>
                
                <span className="item-subtitle">{data.subtitle}</span>

            </div>

        </div>
        

        <div className="item-right">

            <span className="item-amount">
                {taxedAmount.toLocaleString()}€
            </span>

            {edit &&
                <IconButton onClick={onRemove} sx={{ml: 1}}>
                    <Delete/>
                </IconButton>
            }

        </div>

    </div>
}